module.exports = __webpack_public_path__ + "img/petal_0.a54ce3da.png";